import { makeStyles } from "@material-ui/core";
import { blue, grey } from "@material-ui/core/colors";

const mainText = {
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: 1.5,
};

export default makeStyles((theme) => ({
  uploadContainer: {
    width: "100%",
    height: "188px",
    border: `1px dashed ${blue[400]}`,
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(3),
  },
  uploadText: {
    ...mainText,
    color: grey[800],
    textAlign: "center",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  fileInput: {
    display: "none",
  },
  uploadButton: {
    textTransform: "none",
    color: blue[600],
    borderColor: blue[400],
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: grey[50],
    },
  },
  filePreview: {
    justifyContent: "space-between",
    width: "100%",
    border: `1px solid ${grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(3),
    backgroundColor: grey[100],
    padding: theme.spacing(0.5, 1),
    alignSelf: "stretch",
  },
  fileImage: {
    width: "40px",
    height: "40px",
    objectFit: "contain",
    marginRight: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
  },
  fileName: {
    ...mainText,
    color: "black",
  },
  infoBlock: {
    marginTop: theme.spacing(2),
    alignItems: "center",
  },
  dragging: {
    border: `2px dashed ${blue[400]}`,
  },
}));
